import React, { forwardRef, useContext } from 'react';
import styled from 'styled-components';
import { CheckableBase } from '../CheckableBase/CheckableBase.js';
export { defaultProps } from '../CheckableBase/CheckableBase.js';
import '../CheckboxGroup/CheckboxGroup.js';
import { CheckboxGroupContext } from '../CheckboxGroup/ChecboxGroupContext.js';
import { Indicator } from './CheckboxIndicator.js';

const _Checkbox = forwardRef((props, ref) => {
    const groupContext = useContext(CheckboxGroupContext);
    return (React.createElement(CheckableBase, { ...groupContext, ...props, indicator: Indicator, type: "checkbox", ref: ref }));
});
_Checkbox.displayName = '_Checkbox';
const Checkbox = styled(_Checkbox) ``;

export { Checkbox };
//# sourceMappingURL=Checkbox.js.map
